const styles = (theme) => ({
  card: {
    padding: "0px 15px",
    maxWidth: 800,
    backgroundColor: theme.ModalBGColor,
    borderLeft: `10px solid ${theme.ModalBGColor}`,
    marginBottom: 16,
  },
  cardLeftBorderMissedBill: {
    borderLeft: `10px solid ${theme.ErrorMessageColor}`,
  },
  cardLeftBorderExtraBill: {
    borderLeft: `10px solid ${theme.trailerExtraBillsColor}`,
  },
  container: {
    display: "flex",
    justifyContent: "space-between",
    lineHeight: "2.5rem",
    color: theme.gridTextColor,
  },
  subContainerLeft: {
    padding: "0 5px 0 0",
  },
  subContainerRight: {
    padding: "0 0 0 5px",
  },
  proId: {
    textDecoration: "underline",
    fontSize: 14,
    color: theme.palette.primary.main,
    cursor: "pointer",
  },
  addressHeader: {
    fontSize: 16,
    fontWeight: 600,
  },
  keySmall: {
    fontSize: 12,
  },
  valueSmall: {
    fontSize: 12,
    fontWeight: 600,
    paddingRight: 15,
  },
  key: {
    fontSize: 14,
  },
  value: {
    fontSize: 14,
    fontWeight: 600,
  },
  currentLocDiv: {
    color: theme.palette.primary.main,
    backgroundColor: theme.lightPrimaryColor,
    fontWeight: 600,
    borderRadius: 20,
    display: "flex",
    justifyContent: "center",
  },
  valueLarger: {
    fontSize: 22,
    fontWeight: 600,
    color: theme.gridTextColor,
  },
  colorMissedBill: {
    color: theme.ErrorMessageColor,
  },
  colorExtraBill: {
    color: theme.trailerExtraBillsColor,
  },
  planned: {
    lineHeight: "1.5rem",
    paddingTop: 20,
    textAlign: "right",
  },
  divKeyValueList: {
    display: "flex",
    flexWrap: "wrap",
  },
  shipmentLocation: {
    fontSize: 14,
    lineHeight: "1rem",
    padding: 12,
    textTransform: "capitalize",
  },
  rightPadding: {
    paddingRight: 30,
  },
});

export default styles;
